import React, { useEffect } from "react";
import PageDescription from "../../layout/page-description";
import UserCompanyPicker from "../../layout/user-company-picker";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import companyService from "../../services/company.service";
import ercEntityService, { ErcEntity } from "../../services/erc-entity.service";
import PrintPre from "../../layout/print-pre";
import TableNeogen from "../../layout/table-neogen";
import userCompanyService from "../../services/user-company.service";
import userService from "../../services/user.service";
import { use } from "i18next";
import ModalDialog from "../../layout/modal-dialog";
import InputControlled from "../../layout/input-controlled";
import dealsService from "../../services/deals.service";
import { id } from "date-fns/locale";
import { set } from "lodash";
import SelectNeoGen from "../../layout/select-neogen";
import dealTagOptionsService from "../../services/deal-tag-options.service";
import ButtonNeoGen from "../../layout/button-neogen";
const USDollar = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
});
function ErcEntities() {
    const queryClient = useQueryClient();
    const [showCompanyPicker, setShowCompanyPicker] = React.useState(false);
    const [showDealTagManager, setShowDealTagManager] = React.useState(false);
    const [showRefunds, setShowRefunds] = React.useState(false);
    const [showReceived, setShowReceived] = React.useState(false);
    const [showAmountFiled, setShowAmountFiled] = React.useState(false);
    const [showDidIrsIssueRefund, setShowDidIrsIssueRefund] = React.useState(false);
    const [ignoreFields, setIgnoreFields] = React.useState<string[]>([]);
    const [currentFieldName, setCurrentFieldName] = React.useState("");
    const [showEdit, setShowEdit] = React.useState(false);
    const [totalRefundBeforeInterest, setTotalRefundBeforeInterest] = React.useState(0);
    const [totalClearErcFees, setTotalClearErcFees] = React.useState(0);
    const [currentEntry, setCurrentEntry] = React.useState<ErcEntity | null>(null);
    const [dealPayTypes, setDealPayTypes] = React.useState<string[]>([]);
    const [showAffiliateInfo, setShowAffiliateInfo] = React.useState(false);
    const [showAmountOnFile, setShowAmountOnFile] = React.useState(false);
    const [showCpaTaxAttorneyDetails, setShowCpaTaxAttorneyDetails] = React.useState(false);
    const [showIssues, setShowIssues] = React.useState(false);
    const [showCosts, setShowCosts] = React.useState(false);
    const [showContracts, setShowContracts] = React.useState(false);
    const [showQ3Info, setShowQ3Info] = React.useState(false);
    const [newTagName, setNewTagName] = React.useState("");
    useEffect(() => {
        const fields = ["address", "city", "state", "country", "phone", "email", "website", "defaultFolder", "name"];
        if (!showRefunds) {
            fields.push(
                "amountOfRefundIssuedForQ2_2020",
                "amountOfRefundIssuedForQ3_2020",
                "amountOfRefundIssuedForQ4_2020",
                "amountOfRefundIssuedForQ1_2021",
                "amountOfRefundIssuedForQ2_2021",
                "amountOfRefundIssuedForQ3_2021",
                "amountOfRefundIssuedForQ4_2021",
            );
        }
        if (!showReceived) {
            fields.push(
                "didIrsRecieveQ2_2020",
                "didIrsRecieveQ3_2020",
                "didIrsRecieveQ4_2020",
                "didIrsRecieveQ1_2021",
                "didIrsRecieveQ2_2021",
                "didIrsRecieveQ3_2021",
                "didIrsRecieveQ4_2021",
            );
        }
        if (!showDidIrsIssueRefund) {
            fields.push(
                "didTheIrsIssueARefundForQ2_2020",
                "didTheIrsIssueARefundForQ3_2020",
                "didTheIrsIssueARefundForQ4_2020",
                "didTheIrsIssueARefundForQ1_2021",
                "didTheIrsIssueARefundForQ2_2021",
                "didTheIrsIssueARefundForQ3_2021",
                "didTheIrsIssueARefundForQ4_2021",
            );
        }
        if (!showAmountFiled) {
            fields.push(
                "q2_2020_941XAmountFiled",
                "q3_2020_941XAmountFiled",
                "q4_2020_941XAmountFiled",
                "q1_2021_941XAmountFiled",
                "q2_2021_941XAmountFiled",
                "q3_2021_941XAmountFiled",
                "q4_2021_941XAmountFiled",
            );
        }
        if (!showAmountOnFile) {
            fields.push(
                "amountOnFileWithTheIrsForQ2_2020",
                "amountOnFileWithTheIrsForQ3_2020",
                "amountOnFileWithTheIrsForQ4_2020",
                "amountOnFileWithTheIrsForQ1_2021",
                "amountOnFileWithTheIrsForQ2_2021",
                "amountOnFileWithTheIrsForQ3_2021",
                "amountOnFileWithTheIrsForQ4_2021",
            );
        }
        if (!showCosts) {
            fields.push(
                "taxAdvocacyFee",
                "taxAdvocacyFeePaid",
                "amountStillOwed",
                "amountStillOwedWithoutQ3",
                "q3MoneyThatWeMayHaveToRefund",
                "totalRefundsIssued",
                "isThereATaxLiability",
                "howMuchOfErcCreditTransferredDueToTaxLiability",
                "taxAttorneyProjectedCosts",
                "taxAttorneyProjectedCostsPaid",
                "taxAttorneyProjectedCostsOwed",
                "totalCpaCosts",
                "cpaCostsPaid",
                "cpaCostsStillOwed",
                "totalTaxAttorneyCosts",
                "taxAttorneyCostsPaid",
                "taxAttorneyCostsOwed",
                "totalOtherCosts",
                "otherCostsPaid",
                "otherCostsStillOwed",
                "totalCommissionsAndCosts",
                "estimatedFutureCostToSubstantiateFile",
                "estimatedPastInHouseCosts",
                "estimatedFlatRateToFixAFile",
                "estimatedFutureInhouseCostsAt_25kPerMonthFor_5yrs",
            );
        }
        if (!showIssues) {
            fields.push(
                "anyIssuesWithQ2_2020IrsTranscripts",
                "anyIssuesWithQ3_2020IrsTranscripts",
                "anyIssuesWithQ4_2020IrsTranscripts",
                "anyIssuesWithQ1_2021IrsTranscripts",
                "anyIssuesWithQ2_2021IrsTranscripts",
                "anyIssuesWithQ3_2021IrsTranscripts",
                "anyIssuesWithQ4_2021IrsTranscripts",
                "issuesWithQ3_2020IrsTranscripts",
                "issuesWithQ3_2020IrsTranscripts",
                "issuesWithQ3_2020IrsTranscripts",
                "issuesWithQ3_2020IrsTranscripts",
                "issuesWithQ3_2020IrsTranscripts",
                "issuesWithQ3_2020IrsTranscripts",
                "issuesWithQ3_2020IrsTranscripts",
            );
        }
        if (!showCpaTaxAttorneyDetails) {
            fields.push(
                "cpaOnFile",
                "totalCpaCosts",
                "cpaCostsPaid",
                "cpaCostsStillOwed",
                "totalTaxAttorneyCosts",
                "taxAttorneyCostsPaid",
                "taxAttorneyCostsOwed",
                "cpaFutureMaintenanceAndAppealCosts",
            );
        }
        if (!showContracts) {
            fields.push("isThereAContract", "isThereAClawbackContract");
        }
        if (!showQ3Info) {
            fields.push(
                "didWeFileQ3_941X",
                "q3_2021_941XAmountFiled",
                "didIrsRecieveQ3_2021",
                "anyIssuesWithQ3_2021IrsTranscripts",
                "amountOnFileWithTheIrsForQ3_2021",
                "didTheIrsIssueARefundForQ3_2021",
                "amountOfRefundIssuedForQ3_2021",
                "wasThereAQ3Disallowance",
                "amountStillOwedWithoutQ3",
                "q3MoneyThatWeMayHaveToRefund",
                "netRevenueWithQ3",
                "netRevenueAsAPercentageOfFeesWithQ3",
                "netRevenueWithoutQ3",
                "netRevenueAsAPercentageOfFeesWithoutQ3",
            );
        }
        if (!showAffiliateInfo) {
            fields.push(
                "mainAffiliateName",
                "mainAffiliatePercentage",
                "mainAffiliateCommissionsBasedOnAmountRefunded",
                "totalMainAffiliateCommissionDueBasedOnFeesAlreadyPaid",
                "currentPaidMainAffiliateCommission",
                "currentStillOwedMainAffiliateCommission",
                "totalMainAffiliateCommissionBasedOnOverallClearErcFees",
                "potentialFutureStillOwedMainAffiliateCommission",
                "subAffiliateName",
                "subAffiliatePercentage",
                "subAffiliateCommissionBasedOnAmountRefunded",
                "totalSubAffiliateCommissionDueBasedOnFeesAlreadyPaid",
                "currentPaidSubAffiliateCommission",
                "currentStillOwedSubAffiliateCommission",
                "totalSubAffiliateCommissionBasedOnOverallClearErcFees",
                "potentialFutureStillOwedSubAffiliateCommission",
                "mikesRelatedCommissionPercentage",
                "amountDueToMikeBasedOnAmountRefunded",
                "totalMikesCommissionDueBasedOnFeesAlreadyPaid",
                "currentPaidMikesCommission",
                "currentStillOwedMikesCommission",
                "totalMikesCommissionBasedOnOverallClearErcFees",
                "potentialFutureStillOwedMikesAffiliateCommission",
                "jacobsRelatedCommissionPercentage",
                "amountDueToJacobBasedOnAmountRefunded",
                "totalJacobsCommissionDueBasedOnFeesAlreadyPaid",
                "currentPaidJacobsCommission",
                "currentStillOwedJacobsCommission",
                "totalJacobsCommissionBasedOnOverallClearErcFees",
                "potentialFutureStillOwedJacobsAffiliateCommission",
                "tomsRelatedCommissionPercentage",
                "amountDueToTomBasedOnAmountRefunded",
                "totalTomsCommissionDueBasedOnFeesAlreadyPaid",
                "currentPaidTomsCommission",
                "currentStillOwedTomsCommission",
                "totalTomsCommissionBasedOnOverallClearErcFees",
                "potentialFutureStillOwedTomsAffiliateCommission",
                "affiliateOnAccount",
                "affliateGroupTeam",
                "affiliatteRefundLiabilityForAmountAlreadyPaid",
            );
        }
        setIgnoreFields(fields);
    }, [
        showRefunds,
        showReceived,
        showAmountFiled,
        showDidIrsIssueRefund,
        showAffiliateInfo,
        showAmountOnFile,
        showIssues,
        showCpaTaxAttorneyDetails,
        showCosts,
        showContracts,
        showQ3Info,
    ]);

    const companiesQuery = useQuery(["companies"], async () => {
        const response = await companyService.getAll();
        if (response) {
            return response.data;
        }
    });
    const ercEntitiesQuery = useQuery(["erc-entities"], async () => {
        const response = await ercEntityService.getAll();
        if (response) {
            return response.data;
        }
    });
    const userCompanyQuery = useQuery(["user-company"], async () => {
        const response = await userCompanyService.getAll();
        if (response) {
            return response.data;
        }
    });
    const ercUserQuery = useQuery(["erc-users"], async () => {
        const response = await userService.getAll();
        if (response) {
            return response.data;
        }
    });
    const dealTagOptionsQuery = useQuery(["deal-tag-options"], async () => {
        const response = await dealTagOptionsService.getAll();
        if (response) {
            return response.data;
        }
    });
    const dealsQuery = useQuery(["deals"], async () => {
        const response = await dealsService.getAll();
        if (response) {
            const finalResponse = response.data.map((d) => {
                // totalRefundBeforeInterestCount += Number(
                //     d.clientRefundAmountBasedOn_941XsBeforeInterest.replace(/[^0-9.-]+/g, ""),
                // );
                // console.log(
                //     d.companyName,
                //     USDollar.format(Number(d.clientRefundAmountBasedOn_941XsBeforeInterest.replace(/[^0-9.-]+/g, ""))),
                // );
                return {
                    id: d.id,
                    ...d,
                    wasTheDealFinanced: d.wasTheDealFinanced.toString().toUpperCase().trim() === "YES",
                    isAPeo: d.isAPeo.toString().toUpperCase().trim() === "YES",
                    wasThereARequestForMoneyBack:
                        d.wasThereARequestForMoneyBack.toString().toUpperCase().trim() === "YES",
                    didWeFileQ3_941X: d.didWeFileQ3_941X.toString().toUpperCase().trim() === "YES",
                    // wasThereAQ3Disallowance: d.wasThereAQ3Disallowance.toString().toUpperCase().trim() === "YES",
                };
            });
            return finalResponse;
        }
    });
    useEffect(() => {
        let totalRefundBeforeInterestCount = 0;
        let totalClearErcFeesCount = 0;
        const payTypes: string[] = [];
        dealsQuery.data?.map((d) => {
            totalRefundBeforeInterestCount += Number(
                d.clientRefundAmountBasedOn_941XsBeforeInterest.replace(/[^0-9.-]+/g, ""),
            );
            totalClearErcFeesCount += Number(d.clearErcFees.replace(/[^0-9.-]+/g, ""));
            if (!payTypes.includes(d.dealPayType.trim())) {
                payTypes.push(d.dealPayType.trim());
            }
            // console.log(
            //     d.companyName,
            //     USDollar.format(Number(d.clientRefundAmountBasedOn_941XsBeforeInterest.replace(/[^0-9.-]+/g, ""))),
            // );
        });

        setTotalRefundBeforeInterest(totalRefundBeforeInterestCount);
        setTotalClearErcFees(totalClearErcFeesCount);
        setDealPayTypes(payTypes);
        // alert(USDollar.format(totalRefundBeforeInterestCount));
    }, [dealsQuery.data]);
    if (
        companiesQuery.isLoading ||
        ercEntitiesQuery.isLoading ||
        userCompanyQuery.isLoading ||
        ercUserQuery.isLoading ||
        dealsQuery.isLoading
    ) {
        return <div>Loading...</div>;
    }

    return (
        <div>
            <PageDescription
                title="ERC Entities"
                description="ERC entities are the entities that are created by the ERC protocol."
                buttons={[
                    {
                        label: "Manage Deal Tag Options",
                        type: "primary",
                        onClick: () => setShowDealTagManager(true),
                    },
                    {
                        label: showRefunds ? "Hide Refunds" : "Show Refunds",
                        type: showRefunds ? "danger" : "info",
                        onClick: () => setShowRefunds(!showRefunds),
                    },
                    {
                        label: showReceived ? "Hide Received" : "Show Received",
                        type: showReceived ? "danger" : "info",
                        onClick: () => setShowReceived(!showReceived),
                    },
                    {
                        label: showAmountFiled ? "Hide Amount Filed" : "Show Amount Filed",
                        type: showAmountFiled ? "danger" : "info",
                        onClick: () => setShowAmountFiled(!showAmountFiled),
                    },
                    {
                        label: showDidIrsIssueRefund ? "Hide Did IRS Issue Refund" : "Show Did IRS Issue Refund",
                        type: showDidIrsIssueRefund ? "danger" : "info",
                        onClick: () => setShowDidIrsIssueRefund(!showDidIrsIssueRefund),
                    },
                    {
                        label: showAffiliateInfo ? "Hide Affiliate Info" : "Show Affiliate Info",
                        type: showAffiliateInfo ? "danger" : "info",
                        onClick: () => setShowAffiliateInfo(!showAffiliateInfo),
                    },
                    {
                        label: showAmountOnFile ? "Hide Amount On File With IRS" : "Show Amount On File With IRS",
                        type: showAmountOnFile ? "danger" : "info",
                        onClick: () => setShowAmountOnFile(!showAmountOnFile),
                    },
                    {
                        label: showIssues ? "Hide Issues On Transcripts" : "Show Issues On Transcripts",
                        type: showIssues ? "danger" : "info",
                        onClick: () => setShowIssues(!showIssues),
                    },
                    {
                        label: showCpaTaxAttorneyDetails
                            ? "Hide CPA/Tax Attorney Details"
                            : "Show CPA/Tax Attorney Details",
                        type: showCpaTaxAttorneyDetails ? "danger" : "info",
                        onClick: () => setShowCpaTaxAttorneyDetails(!showCpaTaxAttorneyDetails),
                    },
                    {
                        label: showCosts ? "Hide Costs" : "Show Costs",
                        type: showCosts ? "danger" : "info",
                        onClick: () => setShowCosts(!showCosts),
                    },
                    {
                        label: showQ3Info ? "Hide Q3 Info" : "Show Q3 Info",
                        type: showQ3Info ? "danger" : "info",
                        onClick: () => setShowQ3Info(!showQ3Info),
                    },
                    {
                        label: showContracts ? "Hide Contract Info" : "Show Contract Info",
                        type: showContracts ? "danger" : "info",
                        onClick: () => setShowContracts(!showContracts),
                    },
                ]}
            />

            {/* <PrintPre>{dealsQuery.data}</PrintPre> */}
            <div
                className={
                    "bg-gradient-to-br to-slate-100 from-slate-200 dark:from-slate-900 " +
                    " dark:to-gray-800 border border-white rounded-xl  dark:bg-gray-800 " +
                    " dark:border-gray-700 dark:shadow-inner min-h-32 grid grid-cols-1 " +
                    " content-center shadow mb-5 p-5"
                }
            >
                <div>Total Refund Before Interest: {USDollar.format(totalRefundBeforeInterest)}</div>
                <div>Total ClearERC Fees: {USDollar.format(totalClearErcFees)}</div>
                <div>Average Percentage: {((totalClearErcFees / totalRefundBeforeInterest) * 100).toFixed(2)}%</div>
                <div>
                    <ButtonNeoGen
                        onClick={() => {
                            console.log("clicked");
                        }}
                    >
                        Add Filter
                    </ButtonNeoGen>
                </div>
            </div>
            {/* <div>
                Deal Pay Types:{" "}
                {dealPayTypes.map((dp) => {
                    return (
                        <span
                            key={dp}
                            className="inline-flex items-center rounded-full bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10"
                        >
                            {dp}
                        </span>
                    );
                })}
            </div> */}
            <TableNeogen
                entries={dealsQuery.data ?? []}
                formatters={[
                    { field: "wasTheDealFinanced", type: "Boolean" },
                    { field: "isAPeo", type: "Boolean" },
                    { field: "wasThereARequestForMoneyBack", type: "Boolean" },
                    { field: "didWeFileQ3_941X", type: "Boolean" },
                    // { field: "wasThereAQ3Disallowance", type: "Boolean" },
                    { field: "dealPayType", type: "DealTag" },
                    { field: "dealPayStatus", type: "DealTag" },
                    { field: "didTheIrsIssueARefundFullPartialOrNone", type: "DealTag" },
                    { field: "wasThereAQ3Disallowance", type: "DealTag" },
                    { field: "isThereMonitoring", type: "DealTag" },
                    { field: "whatTypeOfMonitoring", type: "DealTag" },
                    { field: "affliateGroupTeam", type: "DealTag" },
                    { field: "affiliateOnAccount", type: "DealTag" },
                    { field: "cpaOnFile", type: "DealTag" },
                    { field: "doesTheFileHaveASubstantiationPackage", type: "DealTag" },
                ]}
                ignoreFields={ignoreFields}
            />
            {/* <TableNeogen
                entries={(ercEntitiesQuery.data ?? []).map((e) => {
                    const users = userCompanyQuery.data?.filter((uc) => uc.companyId === e.ownedBy);
                    const affiliateNames = users
                        ?.filter((u) => u.roleGroupId === 7)
                        ?.map((user) => {
                            console.log({ user });
                            const fullUser = ercUserQuery.data?.find((u) => u.id === user.ercUserId)?.name;
                            console.log({ fullUser });
                            return fullUser;
                        })
                        .join(", ");
                    return {
                        ...e,
                        affiliates: affiliateNames,
                    };
                })}
                formatters={[
                    { field: "ownedBy", type: "CompanyLink" },
                    {
                        field: "paidInFull",
                        type: "Boolean",
                    },
                    {
                        field: "filedQ3_2021",
                        type: "Boolean",
                    },
                    {
                        field: "q3_2021Disallowance",
                        type: "Boolean",
                    },
                ]}
                actions={[
                    {
                        label: "Edit",
                        type: "primary",
                        onClick: (e) => {
                            console.log(e);
                            setCurrentEntry(ercEntitiesQuery.data?.find((entry) => entry.id === e) ?? null);
                            setShowEdit(true);
                        },
                    },
                ]}
                ignoreFields={ignoreFields}
            /> */}
            <UserCompanyPicker
                open={showCompanyPicker}
                setOpen={setShowCompanyPicker}
                showUsers={false}
                showCompanies={true}
                companyList={companiesQuery.data}
                setCompany={async (c) => {
                    // console.log(c);

                    await ercEntityService.create({
                        id: c.id,
                        name: c.name,
                        // address: c.address,
                        // city: c.city,
                        // state: "TS",
                        // country: "USA",
                        // phone: "123-456-7890",
                        // email: "",
                        // website: "",
                        // defaultFolder: 1,
                        ownedBy: c.id,
                    });
                    // alert(c.id);
                    queryClient.invalidateQueries(["erc-entities"]);
                    setShowCompanyPicker(false);
                }}
            />
            <ModalDialog
                show={showDealTagManager}
                close={() => setShowDealTagManager(false)}
                size="lg"
                title="Deal Tag Manager"
                showOk={false}
                cancelText="Close"
                okAction={() => {
                    setShowDealTagManager(false);
                }}
            >
                <div>
                    <SelectNeoGen
                        label="Field Name"
                        options={
                            Object.keys(dealsQuery.data?.[0] ?? {}).map((key) => {
                                return { name: key, id: key };
                            }) ?? []
                        }
                        value={currentFieldName}
                        onChange={(e) => {
                            setCurrentFieldName(e.toString());
                        }}
                    />
                    {currentFieldName && (
                        <div className="mt-5 grid grid-cols-2 items-end">
                            <InputControlled
                                value={newTagName}
                                label="New Tag Name"
                                onChange={(e) => {
                                    setNewTagName(e);
                                }}
                            />
                            <ButtonNeoGen
                                className="mb-5 ml-5"
                                onClick={async () => {
                                    await dealTagOptionsService.create({
                                        fieldName: currentFieldName,
                                        name: newTagName,
                                    });
                                    await queryClient.invalidateQueries(["deal-tag-options"]);
                                    setNewTagName("");
                                }}
                            >
                                Add Tag
                            </ButtonNeoGen>
                        </div>
                    )}
                    <div className="text-gray-400 text-sm block">Existing Tags</div>
                    <div className="mt-5 flex gap-2 flex-wrap">
                        {(dealTagOptionsQuery.data?.filter((d) => d.fieldName === currentFieldName) ?? [])
                            .sort((a, b) => a.name.localeCompare(b.name))
                            .map((d) => {
                                return (
                                    <span
                                        key={d.id}
                                        className="inline-flex items-center gap-x-0.5 rounded-md bg-gray-50 px-2 py-1 text-sm font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10"
                                    >
                                        {d.name}
                                        <button
                                            type="button"
                                            className="group relative -mr-1 size-3.5 rounded-sm hover:bg-gray-500/20"
                                            onClick={async () => {
                                                console.log(d);
                                                await dealTagOptionsService.deleteByID(d.id);
                                                await queryClient.invalidateQueries(["deal-tag-options"]);
                                            }}
                                        >
                                            <span className="sr-only">Remove</span>
                                            <i className="fal fa-times" />
                                            <span className="absolute -inset-1" />
                                        </button>
                                    </span>
                                );
                            })}
                    </div>
                    {/* <TableNeogen
                        entries={dealTagOptionsQuery.data?.filter((d) => d.fieldName === currentFieldName) ?? []}
                    />
                    <PrintPre>{dealTagOptionsQuery.data}</PrintPre> */}
                </div>
            </ModalDialog>
            <ModalDialog
                show={showEdit}
                close={() => setShowEdit(false)}
                size="md"
                title="Edit ERC Entity"
                okAction={() => {
                    setShowEdit(false);
                }}
            >
                <div>
                    <form>
                        {/* <InputControlled
                            label="Name"
                            value={currentEntry?.name ?? ""}
                            onChange={(e) => {
                                setCurrentEntry({ ...(currentEntry ?? ""), name: e });
                            }}
                        />
                        <InputControlled
                            label="Address"
                            value={currentEntry?.address ?? ""}
                            onChange={(e) => {
                                setCurrentEntry({ ...(currentEntry ?? ""), address: e });
                            }}
                        />
                        <InputControlled
                            label="City"
                            value={currentEntry?.city ?? ""}
                            onChange={(e) => {
                                setCurrentEntry({ ...(currentEntry ?? ""), city: e });
                            }}
                        />
                        <InputControlled
                            label="State"
                            value={currentEntry?.state ?? ""}
                            onChange={(e) => {
                                setCurrentEntry({ ...(currentEntry ?? ""), state: e });
                            }}
                        />
                        <InputControlled
                            label="Country"
                            value={currentEntry?.country ?? ""}
                            onChange={(e) => {
                                setCurrentEntry({ ...(currentEntry ?? ""), country: e });
                            }}
                        />
                        <InputControlled
                            label="Phone"
                            value={currentEntry?.phone ?? ""}
                            onChange={(e) => {
                                setCurrentEntry({ ...(currentEntry ?? ""), phone: e });
                            }}
                        />
                        <InputControlled
                            label="Email"
                            value={currentEntry?.email ?? ""}
                            onChange={(e) => {
                                setCurrentEntry({ ...(currentEntry ?? ""), email: e });
                            }}
                        />
                        <InputControlled
                            label="Website"
                            value={currentEntry?.website ?? ""}
                            onChange={(e) => {
                                setCurrentEntry({ ...(currentEntry ?? ""), website: e });
                            }}
                        />
                        <InputControlled
                            label="Default Folder"
                            value={currentEntry?.defaultFolder ?? ""}
                            onChange={(e) => {
                                setCurrentEntry({ ...(currentEntry ?? ""), defaultFolder: e });
                            }}

                        />
                        <InputControlled
                            label="Owned By"
                            value={currentEntry?.ownedBy ?? ""}
                            onChange={(e) => {
                                setCurrentEntry({ ...(currentEntry ?? ""), ownedBy: e });
                            }}
                        /> 
                        <InputControlled
                            label="Paid In Full"
                            value={currentEntry?.paidInFull ? "Yes" : "No" ?? ""}
                            onChange={(e) => {
                                setCurrentEntry({ ...(currentEntry ?? ""), paidInFull: e?.toString() as any });
                            }}
                        />
                        <InputControlled
                            label="Fee Percentage"
                            value={currentEntry?.feePercentage ?? ""}
                            onChange={(e) => {
                                setCurrentEntry({ ...(currentEntry ?? ""), feePercentage: e });
                            }}
                        />
                        <InputControlled
                            label="Deal Pay Status"
                            value={currentEntry?.dealPayStatus ?? ""}
                            onChange={(e) => {
                                setCurrentEntry({ ...(currentEntry ?? ""), dealPayStatus: e });
                            }}
                        />
                        <InputControlled
                            label="Refund Before Interest Q2 2020"
                            value={currentEntry?.refundBeforeInterestQ2_2020 ?? ""}
                            onChange={(e) => {
                                setCurrentEntry({ ...(currentEntry ?? ""), refundBeforeInterestQ2_2020: e });
                            }}
                        />
                        <InputControlled
                            label="Refund Before Interest Q3 2020"
                            value={currentEntry?.refundBeforeInterestQ3_2020 ?? ""}
                            onChange={(e) => {
                                setCurrentEntry({ ...(currentEntry ?? ""), refundBeforeInterestQ3_2020: e });
                            }}
                        />
                        */}
                    </form>
                    <PrintPre>{currentEntry}</PrintPre>
                </div>
            </ModalDialog>
        </div>
    );
}

export default ErcEntities;
